<template>
  <div v-if="$store.state.module">
    <div class="home">
      <div id="search_container">
        <div class="search_form">
          <b-button class="search_button">
            <b-icon icon="search"></b-icon>
          </b-button>
          <b-form-input class="search_field" placeholder="Rechercher par dossard" type="number" v-model="searchFilter"
            @input="searchPhotos()" size="sm"></b-form-input>

        </div>
        <p class="search_tooltip">
          A l'aide de votre dossard, nous allons identifier les photos prises
          aux alentours de vos temps de passages.
        </p>
      </div>
      <!-- Afficher galerie complète -->
      <div v-if="all_displayed">
        <Gallery v-if="has_images_loaded" :images="images"></Gallery>
        <div v-else class="error_galerie">
          <h2>Désolé, aucune photo n'a été trouvée...</h2>
        </div>
        <b-button v-if="moreToLoad" @click="loadMore">Charger plus de photos</b-button>
      </div>
      <!-- Afficher galerie d'un coureur -->
      <div v-else class="mt-4">

        <b-container v-if="list_type_point.length > 1">
          <b-row>
            <b-col>
              <div class="text-white">
                Nouveauté: retrouvez vos photos par point de passage
              </div>
              <b-tabs pills card align="center" class="tabs_select_type"
                active-nav-item-class="font-weight-bold text-white bg-orange-sportips">
                <b-tab v-for="(type_point, index) in list_type_point" :title="type_point" :key="index"
                  :active="index = 0">
                  <Gallery v-if="has_images_loaded" :images="get_point_images(type_point)"></Gallery>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
        </b-container>
        <Gallery v-else :images="images"></Gallery>
        <div v-if="!has_images_loaded" class="error_galerie">
          <h2>Désolé, aucune photo n'a été trouvée...</h2>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Gallery from "@/components/Gallery.vue";

export default {
  name: "Home",
  components: {
    Gallery,
  },
  data() {
    return {
      moreToLoad: true,
      page: 0,
      searchFilter: "",
      images: [],
      firstload: false,
      selected_type_point: "arrivee",
    };
  },
  computed: {
    list_type_point() {
      const types = this.images.map(image => image.type_point);
      // reverse the array
      types.reverse();
      // Remove duplicates
      const uniqueTypes = [...new Set(types)];
      return uniqueTypes;


    },
    all_displayed() {
      return this.searchFilter == '';
    },
    has_images_loaded() {
      return this.images.length > 0;
    }
  },
  methods: {
    get_point_images(type_point) {
      return this.images.filter(image => image.type_point === type_point);
    },
    emptySearch() {
      if (this.searchFilter === "") {
        this.searchPhotos();
      }
    },
    loadMore() {
      this.page++;
      var _this = this;
      axios
        .get(
          this.$store.state.base_url +
          "/list_photos/get.php?module=" +
          this.$route.params.base +
          "&id_module=" +
          this.$store.state.module.id +
          "&search=" +
          this.searchFilter +
          "&page=" +
          this.page
        )
        .then(function (response) {
          _this.images = _this.images.concat(response.data);
          _this.moreToLoad = response.data.length === 200;
        });
    },
    searchPhotos() {
      var _this = this;
      if (this.searchFilter !== "") {
        this.page = 0;
      }
      axios
        .get(
          this.$store.state.base_url +
          "/list_photos/get.php?module=" +
          this.$route.params.base +
          "&id_module=" +
          this.$store.state.module.id +
          "&search=" +
          this.searchFilter +
          "&page=" +
          this.page
        )
        .then(function (response) {
          _this.images = response.data;

          _this.moreToLoad = response.data.length === 200;
        });
    },
  },
  created() {
    this.searchPhotos();
    var _this = this;
    axios
      .get(
        this.$store.state.base_url +
        "/list_photos/get.php?module=" +
        this.$route.params.base +
        "&id_module=" +
        this.$store.state.module.id
      )
      .then(function (response) {
        _this.firstload = true;
        _this.images = response.data;
      });
  },
};
</script>

<style lang="scss"></style>
